// para ver todos los adjuntos, ver attachs.js en carpeta services
const requiredAttachsByOoss = {
  // ACA SALUD
  36: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // SANCOR
  66: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // COMEI
  22: ['frente_orden', 'dorso_orden'],
  // OSAPM
  41: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSAP
  60: ['frente_orden', 'planilla_asistencia'],
  // SWISS MEDICAL S.A.	
  57: ['frente_orden'],
  // STAFF MEDICO
  67: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // AMFFA
  26: ['frente_orden', 'dorso_orden'],
  // AMEBPBA
  49: ['frente_orden', 'planilla_asistencia', 'affiliate_credential', 'autorizacion'],
  // AMSTERDAM SALUD
  80: ['frente_orden', 'dorso_orden'],
  // APRES S.A
  89: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'], // TODO agregar factura en front
  // SANCOR
  66: ['frente_orden'],
  // APSOT
  68: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // MOTOCICLISTAS
  33: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'],
  // CASA
  47: ['frente_orden'],
  // CASA PLAN BAYRES ??
  // undefined
  // COLEGIO DE ESCRIBANOS
  39: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // DASMI
  84: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // DASUTEN
  69: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'], // TODO agregar factura en front
  // E. W. HOPE
  25: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // ENSALUD
  43: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'], // TODO agregar factura en front
  // FEDERADA SALUD
  74: ['frente_orden'],
  // FUTBOLISTAS
  31: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // GALENO
  48: ['frente_orden', 'planilla_asistencia', 'affiliate_credential', 'autorizacion'],
  // GALENODAN
  50: ['frente_orden', 'planilla_asistencia', 'affiliate_credential', 'autorizacion'],
  // IOSFA
  61: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'bono'], // TODO ver q onda el tema de la cantidad de bonos
  // JERARQUICOS
  38: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // LA HOLANDO ART
  34: ['frente_orden', 'dorso_orden', 'planilla_limitacion'], // quitar planilla_asistencia para esta ooss
  // LA SEGUNDA ART
  71: ['frente_orden', 'dorso_orden', 'planilla_limitacion'], // quitar planilla_asistencia para esta ooss
  // LA SEGUNDA PERSONAS
  72: ['frente_orden', 'dorso_orden', 'planilla_limitacion', 'factura'], // quitar planilla_asistencia para esta ooss, TODO agregar factura en front
  // Lpf Grupo La Pequeña Familia
  45: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'bono', 'factura'], // TODO ver q onda el tema de la cantidad de bonos, agregar factura en front
  // LUIS PASTEUR
  30: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // MANDAR SALUD S.A.
  13: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // MEDICAR WORK
  24: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'], // TODO agregar factura en front
  // MEDICUS SA
  53: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // MEDIFE SA
  55: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OPDEA
  86: ['frente_orden', 'dorso_orden', 'planilla_asistencia'], // TODO IMPORTANTE esta es la que tiene 10 bonos o 10 sesiones, manejar
  // OSDOP
  65: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSECAC
  51: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSFATLYF
  87: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'bono'], // TODO ver q onda el tema de la cantidad de bonos
  // OSPE
  77: ['frente_orden', 'dorso_orden'],
  // OSPEDYC
  81: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSPEPBA
  82: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSPIA
  73: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'bono'], // TODO ver q onda el tema de la cantidad de bonos
  // OSPICAL
  64: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSPSA
  70: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'bono'], // TODO ver q onda el tema de la cantidad de bonos
  // OSPTV
  75: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // OSSEG
  35: ['frente_orden', 'dorso_orden'],
  // PODER JUDICIAL
  27: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // PREVENCION SALUD S.A
  85: ['frente_orden', 'dorso_orden', 'planilla_asistencia', 'factura'], // TODO agregar factura en front
  // RECONQUISTA ART S.A
  32: ['frente_orden', 'dorso_orden', 'planilla_limitacion', 'factura'], // quitar planilla_asistencia para esta ooss, TODO agregar factura en front
  // SANPEDRO
  54: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // SCIS S-A
  42: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // SWISS ART (SMG ART)
  83: ['frente_orden', 'planilla_asistencia', 'autorizacion'],
  // UP
  46: ['frente_orden', 'dorso_orden', 'planilla_asistencia'],
  // AL SEGUNDA ART
  71: ['frente_orden', 'planilla_asistencia', 'autorizacion'],
}

export const getRequiredAttachs = (id) => {
  return requiredAttachsByOoss[parseInt(id)] || ['frente_orden', 'dorso_orden'] // frente_orden required in every OOSS
}

export const getAvailableAttachs = (id) => {
  //
}